module.exports = __webpack_public_path__ + "static/delivery-2301c88b210b1c3d05ea61618dbe6204.jpg";